<template>
    <div :class="{ 'global-content': true, 'down-review': !isPreview }" ref="positionBox">
        <div class="watermark-box">
            <div
                :class="'watermark watermark' + item"
                v-for="item in isPreview ? 36 : 18"
                :key="item"
                :style="{
                    top: Math.floor(item / (isPreview ? 6 : 3)) * 16.6 + 6 + '%',
                    left:
                        (item % (isPreview ? 6 : 3)) * (isPreview ? 16.6 : 33.2) +
                        (isPreview ? 5 : 10) +
                        '%',
                }"
                >{{ $store.state.clientele.watermark }}</div
            >
        </div>

        <div class="cover" v-if="!isPreview">
            <div class="pdf-cover-logo">
                <img
                    ref="clienteleLogoCover"
                    class="risk-level"
                    src="../../../static/images/locking-w.png"
                    alt=""
                />
                <div>{{ $store.state.clientele.appletName || '' }}</div>
            </div>

            <div class="pdf-cover-title">
                <div class="pdf-cover-title-surveyName">{{ surveyName || '' }}</div>
                <div class="pdf-cover-title-message">企业法律风险自检系统风险报告</div>
            </div>

            <div class="pdf-cover-time">{{ generationTime }}</div>
        </div>
        <div class="report-left" v-if="isPreview">
            <div style="font-size: 24px">
                <i class="iconfont panda_mobilemulu" style="font-size: 20px"></i>
                报告目录
            </div>
            <li
                :class="{ active: showIndex === 0 }"
                class="report-left-li"
                @click="scrollToArea($event, 0)"
                href="a0"
            >
                <i class="iconfont panda_mobilezonghekongzhitai"></i>
                自检综述
                <span v-show="showIndex === 0"></span>
            </li>
            <li
                :class="{ active: showIndex === index + 1 }"
                class="report-left-li"
                @click="scrollToArea($event, index + 1)"
                :href="'a' + (index + 1)"
                v-for="(item, index) in riskProgressList"
                :key="index"
            >
                <i :class="[{ iconfont: true }, item.img]"></i>
                {{ item.name.moduleName }}风险
                <span v-show="showIndex === index + 1"></span>
            </li>
            <li
                v-if="false"
                class="report-left-li"
                @click="scrollToArea($event, showIndexLaw)"
                :href="'a' + showIndexLaw"
                v-show="isShowLawsData"
            >
                <img src="../../../static/images/laws-icon.png" alt="" />涉诉情况
            </li>
        </div>
        <div class="report-right" :style="{ margin: isPreview ? '0 0 0 250px' : '0 40px' }">
            <div id="pdfCentent">
                <h1></h1>
                <img
                    ref="riskLevel"
                    class="risk-level"
                    src="../../../static/images/locking-w.png"
                    alt=""
                    v-show="!noRisk"
                />
                <div
                    class="row"
                    ref="risk0"
                    style="
                        margin-top: 35px;
                        margin-bottom: 20px;
                        display: flex;
                        justify-content: center;
                    "
                    :class="{ noRisk: noRisk }"
                >
                    <!-- :style="{ 'text-indent': isPreview ? '120px' : '0' }" -->
                    <span class="left"
                        ><label style="font-size: 24px">{{ surveyName }}</label></span
                    >
                </div>
                <div class="row" style="margin-bottom: 39px">
                    <span class="right" style="font-size: 16px; color: #666">
                        检测日期： <label>{{ date }}</label> </span
                    >&emsp;<span class="left1" style="font-size: 16px; color: #666" v-show="!noRisk"
                        >高危风险：<label style="color: red">{{ highRiskNumber }}个</label></span
                    >
                </div>
                <div v-if="noRisk">
                    <img src="../../../static/images/noRisk.png" alt="" />
                </div>
                <div v-else>
                    <div>
                        <h2 class="borLeft2" style="margin-bottom: 20px; line-height: 35px">
                            风险分布
                        </h2>
                        <div
                            class="clearfix bg"
                            style="padding-top: 10px"
                            v-show="riskProgressList.length > 6"
                        >
                            <div ref="riskEchart" class="riskEchart"></div>
                            <div class="riskTable">
                                <div
                                    class="riskList"
                                    v-for="(item, index) in riskRankList"
                                    :key="index"
                                >
                                    <span class="riskList-rank"
                                        ><strong :class="{ rank: index < 3 }">{{
                                            index + 1
                                        }}</strong></span
                                    >
                                    <span class="riskList-name">{{ item.name }}</span>
                                    <span class="riskList-num">{{ item.number }}</span>
                                </div>
                            </div>
                        </div>
                        <div
                            id="riskChange"
                            v-show="riskProgressList.length <= 6"
                            class="clearfix bg"
                            style="padding: 40px 0"
                        >
                            <div id="riskSvg">
                                <a-progress
                                    id="svg"
                                    style="margin-left: 20px"
                                    :width="width"
                                    :strokeWidth="strokeWidth"
                                    v-for="(item, index) in riskProgressList"
                                    :key="index"
                                    :format="() => item.name.moduleName + '\n' + item.number + '个'"
                                    type="circle"
                                    :percent="item.percent"
                                    :strokeColor="item.color"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="row bg txtindent" v-show="breakPromiseNum">
                        <span class="left curpoint"
                            >失信被执行情况：<label>{{ breakPromiseNum }}</label
                            >次
                            <a-button
                                v-if="isPreview"
                                type="primary"
                                @click="showModal"
                                style="float: right; text-align: center; margin: 9px"
                                >查看详情</a-button
                            ></span
                        >
                    </div>
                    <div class="row bg txtindent" v-show="isShowLawsData">
                        <span class="left curpoint" :href="'a' + showIndexLaw"
                            >涉诉情况：你的企业有{{ numFound }}条涉诉风险
                            <a-button
                                v-if="isPreview"
                                type="primary"
                                @click="scrollToArea($event, showIndexLaw)"
                                style="float: right; text-align: center; margin: 9px"
                                >查看详情</a-button
                            >
                        </span>
                    </div>
                    <div id="riskInfoBox">
                        <div
                            class="danger-list panel panel-default"
                            :ref="'risk' + (index + 1)"
                            v-for="(item, index) in riskInfosList"
                            :key="index"
                        >
                            <div class="danger-title a-anchors borLeft2" :ref="'a' + (index + 1)">
                                {{ item.moduleName.moduleName }}风险
                            </div>
                            <div class="detail-list" v-for="(obj, i) in item.riskInfo" :key="i">
                                <div class="detail-header">
                                    <div class="detail-title">
                                        <span>{{ i + 1 > 9 ? i + 1 : '0' + (i + 1) }}</span
                                        >{{ obj.riskTitle }}
                                    </div>
                                    <img
                                        class="detail-header-legalScope"
                                        v-show="obj.legalScope == '1'"
                                        src="../../../static/images/xing.png"
                                    />
                                </div>
                                <div class="detail-analyse form-group clearfix">
                                    <div class="fix-title">风险分析及建议：</div>
                                    <div class="analyseCont">{{ obj.analysis }}</div>
                                </div>
                                <div class="case" v-if="obj.optionCaseList.length > 0">
                                    <span :key="i" v-for="(matter, i) in obj.optionCaseList"
                                        ><em>案例{{ i + 1 }}:</em>&nbsp;&nbsp;<a
                                            target="_blank"
                                            :href="caseUrl + matter.caseId"
                                            >{{ matter.caseTitle }}</a
                                        ></span
                                    >
                                </div>

                                <div v-if="obj.optionLawList.length > 0">
                                    <!-- 
                    defaultActiveKey是根据key进行展开的，lawItem.optionId是重复的key值，但是for循环中key要唯一值，不影响使用，但是会报错
                    Duplicate keys detected: 'xxx'. This may cause an update error.
                  -->
                                    <a-collapse
                                        :bordered="false"
                                        :defaultActiveKey="
                                            isPreview
                                                ? ''
                                                : obj.optionLawList.map((item) => item.lawId)
                                        "
                                        expandIconPosition="right"
                                    >
                                        <a-collapse-panel
                                            v-for="(lawItem, i) in obj.optionLawList"
                                            :key="lawItem.lawId"
                                            :style="customStyle"
                                        >
                                            <template #header>
                                                <span
                                                    ><i class="lawsTitle">法规{{ i + 1 }}: </i
                                                    >{{ lawItem.lawId }}</span
                                                >
                                            </template>
                                            <div>{{ lawItem.lawTitle }}</div>
                                        </a-collapse-panel>
                                    </a-collapse>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        v-if="false"
                        class="echarts-box"
                        :ref="'risk' + showIndexLaw"
                        v-show="isShowLawsData"
                    >
                        <div class="lawuit-title">企业涉诉情况分析</div>
                        <!-- <div class="lawuit-list-title">1、裁判年份</div> -->
                        <div class="echarts-list" ref="echartsYear" id="echartsYear"></div>
                        <!-- <div class="lawuit-list-title">2、案由分布</div> -->
                        <div class="echarts-list" ref="echartsReason" id="echartsReason"></div>
                        <!-- <div class="lawuit-list-title">3、地区分布</div> -->
                        <div class="echarts-list" ref="echartsArea" id="echartsArea"></div>
                        <!-- <div class="lawuit-list-title">4、法院</div> -->
                        <div class="echarts-list" ref="echartsCourt" id="echartsCourt"></div>
                        <!-- <div class="lawuit-list-title">5、审理程序</div> -->
                        <div class="echarts-list" ref="echartsProgress" id="echartsProgress"></div>
                        <!-- <div class="lawuit-list-title">6、律师</div> -->
                        <div class="echarts-list" ref="echartsLawyer" id="echartsLawyer"></div>
                    </div>
                </div>
            </div>
        </div>
        <a-button
            type="primary"
            @click="outPutPdfFn"
            icon="download"
            :class="{
                lock: $lock,
            }"
            style="margin: 20px 0 40px 250px"
            v-show="!noRisk && isPreview"
            >下载报告</a-button
        >
        <div class="shengming" :style="{ 'padding-left': isPreview ? '250px' : '0' }">
            本报告仅根据问卷所选答案信息生成，不代表对公司实际情况的判断，报告结论仅供参考；<br />如有进一步咨询需求请向专业律师寻求帮助。
        </div>
        <a-modal
            title="失信被执行情况详情"
            v-model="visible"
            @ok="handleOk"
            okText="确定"
            cancelText="取消"
            width="700px"
        >
            <div
                v-for="(item, index) in dishonestExecutors"
                :key="index"
                class="dishonest"
                style="background: #efefef; margin-bottom: 10px; padding: 8px; position: relative"
            >
                <span style="position: absolute; top: 5px; right: 5px; color: #bbb"
                    >第{{ index + 1 }}条</span
                >
                <a-row
                    ><a-col :span="spanLeft">法定代表人或者负责人姓名：</a-col
                    ><a-col :span="spanRight">{{ item.name }}</a-col></a-row
                >
                <a-row
                    ><a-col :span="spanLeft">执行法院：</a-col
                    ><a-col :span="spanRight">{{ item.courtName }}</a-col></a-row
                >
                <a-row
                    ><a-col :span="spanLeft">省份：</a-col
                    ><a-col :span="spanRight">{{ item.areaName }}</a-col></a-row
                >
                <a-row
                    ><a-col :span="spanLeft">案号：</a-col
                    ><a-col :span="spanRight">{{ item.caseCode }}</a-col></a-row
                >
                <a-row
                    ><a-col :span="spanLeft">生效法律文书确定的义务：</a-col
                    ><a-col :span="spanRight">{{ item.duty }}</a-col></a-row
                >
                <a-row
                    ><a-col :span="spanLeft">被执行人的履行情况：</a-col
                    ><a-col :span="spanRight">{{ item.performance }}</a-col></a-row
                >
                <a-row
                    ><a-col :span="spanLeft">失信被执行人行为具体情形：</a-col
                    ><a-col :span="spanRight">{{ item.disruptTypeName }}</a-col></a-row
                >
                <a-row
                    ><a-col :span="spanLeft">发布时间：</a-col
                    ><a-col :span="spanRight">{{ item.publishDate }}</a-col></a-row
                >
            </div>
        </a-modal>
        <div v-show="loadingShow" class="loadingBg" style="opacity: 0">
            <div class="loadingBox">
                <div class="loading-title">正在生成报告</div>
                <div class="loading-img">
                    <img src="../../../static/images/loading.png" />
                    <span>{{ loadingPercent }}%</span>
                </div>
                <div class="loading-info" v-if="loadingPercent">
                    正在评估{{ loadingInfo.moduleName }}部分......
                </div>
                <div class="loading-info" v-else>请等待评估......</div>
            </div>
        </div>
    </div>
</template>

<script>
    import { apiListPC } from '@/api'
    import ajax from '@/api/ajax'
    import { ICON_FONT_IMG_MAP } from '@/utils/public'
    import COURT_JSON from '@/utils/json/court.json'
    import { downLoadPDF } from '@/utils/downloadFile/downLoadPDF'
    // import watermark from '@/common/watermark'

    export default {
        name: 'Report',
        created() {
            this.showIndex = 0
            this.loadingShow = true
            this.downloadTimer = null
        },
        beforeMount() {
            if (!this.$route.query.surveyId) {
                this.$message.warning('当前报告已被删除，请查看其他报告！')
                setTimeout(() => [this.$router.replace('/Record')], 1000)
                return false
            }
            if (this.$route.query && this.$route.query.authentication) {
                this.isPreview = false
                const domTopHeader = document.getElementById('topHeader')
                const domBottom = document.getElementsByClassName('bottom')[0]
                domTopHeader && (domTopHeader.style.display = 'none')
                domBottom && (domBottom.style.display = 'none')
                localStorage.setItem('token', this.$route.query.authentication)
                this.loadingPercent = 95
            } else {
                this.isPreview = true
                const domTopHeader = document.getElementById('topHeader')
                domTopHeader && (domTopHeader.style.display = 'inherit')
                const domBottom = document.getElementsByClassName('bottom')[0]
                domBottom && (domBottom.style.display = 'inherit')
            }
            if (this.$route.query && this.$route.query.type) {
                this.getClientele(this.$route.query.type)
            } else {
                this.getClientele('2')
            }
        },
        async mounted() {
            let date = new Date()
            this.generationTime =
                date.getFullYear() + '年' + (date.getMonth() + 1) + '月' + date.getDate() + '日'

            let that = this
            that.bus.$emit('loading', false)
            that.getDishonestExecutors()
            // that.getSurveyLawsuits()
            //获取风险信息
            that.getSurveyRiskInfos()
            //页面添加滚动监听
            that.$nextTick(() => {
                document.addEventListener('scroll', that.changeLeftNav, true)

                let scrTop = document.documentElement || document.body
                scrTop.scrollTop = 0
            })
        },
        destroyed() {
            document.removeEventListener('scroll', this.changeLeftNav, true)
            clearInterval(this.loadingTimer)
            clearInterval(this.downloadTimer)
        },
        data() {
            return {
                generationTime: '',
                visible: false,
                spanRight: 16,
                spanLeft: 8,
                enterpriseCode: '',
                surveyName: '',
                date: '',
                highRiskNumber: 0,
                breakPromiseNum: 0,
                riskProgressList: [],
                riskInfosList: [],
                showIndex: 0,
                isClickScroll: false,
                showIndexLaw: 0,
                dishonestExecutors: [],
                width: 100,
                strokeWidth: 10,
                riskRankList: [],
                loadingShow: false,
                noRisk: false,
                loadingPercent: 0,
                loadingInfo: '',
                loadingTimer: null,
                isShowLawsData: false,
                numFound: 0,
                customStyle: 'background: #ffffff;border: 0;',
                arrobj: {},
                isPreview: true,
                downloadTimer: null,
                iii: 0,
                caseUrl: process.env.VUE_APP_LAWSDATA_URL,
            }
        },

        watch: {
            isShowLawsData: {
                handler(newName) {
                    // 根据 that.showIndexLaw = moduleScore.length + 1;
                    // 监听是否有'涉诉情况',有: 锚点risk的length+1, 没有: 锚点risk的length-1,不然在changeLeftNav时,锚点会定位不准
                    this.isShowLawsData ? (this.showIndexLaw += 1) : (this.showIndexLaw -= 1)
                },
                immediate: true,
                deep: true,
            },
        },
        methods: {
            getClientele(type) {
                this.$store.dispatch('storeGetClientele', {
                    license: this.$route.query.license || sessionStorage.getItem('license'),
                    type,
                })
            },
            async promisAll() {
                await this.getSurveyRiskInfos()
                this.outPutPdfFn()
            },
            async getSurveyLawsuits() {
                let that = this
                let fetchData = await ajax(apiListPC.getSurveyLawsuits, {
                    enterpriseId: that.$route.query.enterpriseId,
                }).catch((err) => {
                    that.isShowLawsData = false
                })

                let lawsuit = fetchData.data.returnData
                if (!lawsuit || lawsuit.numFound < 1) {
                    return false
                }
                that.isShowLawsData = lawsuit.numFound > 0
                that.numFound = lawsuit.numFound

                //绘制裁判年份echarts
                let judgementYearArr = lawsuit.facetFields.judgementYear
                createJudgementYearEcharts(judgementYearArr, that)
                // //绘制案由分布echarts
                let reasonArr = lawsuit.facetFields.reasonId
                createReasonEcharts(reasonArr, that)
                // //绘制地区分布echarts
                let provinceId = lawsuit.facetFields.provinceId
                createProvinceEcharts(provinceId, that)
                // //绘制法院top10echarts
                let courtTop = lawsuit.courtIdListTop10
                createCourtTop0Echarts(courtTop, that)
                // //绘制审理程序分布图
                let procedure = lawsuit.facetFields.procedureId
                createProcedureEcharts(procedure, that)
                // //绘制律师top10echarts
                let lawyerListTop = lawsuit.lawyerListTop10
                createlawyerListTopEcharts(lawyerListTop, that)
            },
            async getSurveyRiskInfos() {
                let that = this
                let fetchData = await ajax(
                    apiListPC.getSurveyRiskInfos,
                    { surveyId: that.$route.query.surveyId },
                    'GET',
                    that
                )

                const data = {
                    returnData: fetchData.data,
                }
                that.surveyName = data.returnData.survey ? data.returnData.survey.surveyName : ''
                that.date = data.returnData.survey
                    ? data.returnData.survey.createTime
                    : getNowFormatDate()

                let riskInfos = data.returnData.riskInfos
                if (riskInfos.length === 0) {
                    that.noRisk = true
                    that.loadingShow = false
                    return
                }
                //动态计算loading展示信息
                let len = riskInfos.length
                let per = 100 / len
                riskInfos.forEach(function (item, index) {
                    item.per = per * (index + 1)
                })
                that.loadingTimer = setInterval(function () {
                    if (that.loadingPercent == 100) {
                        that.loadingTimer = null
                        that.loadingShow = false
                        clearInterval(this.loadingTimer)
                        return
                    }
                    that.loadingPercent += 10
                    riskInfos.some(function (item) {
                        if (item.per >= that.loadingPercent) {
                            that.loadingInfo = item.moduleName
                            return true
                        }
                    })
                }, 0)
                //计算高危风险个数  计算风险总个数
                let highRiskNumber = 0
                let riskNumber = 0
                riskInfos.forEach(function (riskInfo) {
                    riskNumber += riskInfo.riskInfo.length
                    highRiskNumber++
                    // riskInfo.riskInfo.forEach(function (item) {
                    //   if (item.score == '-3' || item.score == '-2') {
                    //     highRiskNumber++;
                    //   }
                    // });
                })
                that.highRiskNumber = highRiskNumber
                //计算风险分布
                let colors = ['#1C8CE1', '#1BDAD3', '#E1D334', '#DE812E', '#F04C2B', '#D84E7F']
                let moduleScore = []
                riskInfos.forEach(function (item, index) {
                    item.img =
                        ICON_FONT_IMG_MAP[item.moduleName.moduleId] || 'panda_mobilebumen-moren'
                    let obj = {
                        name: item.moduleName.moduleName,
                        number: item.riskInfo.length,
                        percent: (item.riskInfo.length * 100) / riskNumber,
                        color: colors[index],
                        img: item.img,
                    }
                    moduleScore.push(obj)
                    let obj2 = {
                        name: item.moduleName,
                        number: item.riskInfo.length,
                        percent: (item.riskInfo.length * 100) / riskNumber,
                        color: colors[index],
                        img: item.img,
                    }
                    that.riskProgressList.push(obj2)
                })
                //that.riskProgressList = moduleScore;
                that.showIndexLaw = moduleScore.length + 1
                that.riskInfosList = data.returnData.riskInfos

                createRiskEcharts(moduleScore, that)
                that.riskRankList = moduleScore.sort(numberSort)

                //获取风险等级
                let level = (data.returnData.survey && parseInt(data.returnData.survey.level)) || 1
                let src
                if (level < 3) {
                    src = require('../../../static/images/risk-low.png')
                } else if (level == 3) {
                    src = require('../../../static/images/risk-middle.png')
                } else {
                    src = require('../../../static/images/risk-high.png')
                }
                that.$refs.riskLevel.src = src

                that.$refs.clienteleLogo &&
                    (that.$refs.clienteleLogo.src = that.$store.state.clientele.imageAddress)

                that.$refs.clienteleLogoCover.src =
                    that.$store.state.clientele.imageAddress ||
                    require('../../../static/images/logo-bashou.png')
                //  不知道为什么要用这个判断？？？
                if (that.$route.query.download != 'true') {
                    setTimeout(function () {
                        that.loadingShow = false
                    }, 20)
                }
            },

            showModal() {
                if (this.breakPromiseNum == 0) {
                    this.$message.warning('该企业无失信被执行情况！')
                    return
                }
                this.visible = true
            },
            handleOk() {
                this.visible = false
            },
            scrollToArea(el, index) {
                this.$nextTick(() => {
                    let obj = 'risk' + index
                    // console.log(obj, 'ddddd')
                    this.isClickScroll = true
                    let scrTop = document.documentElement || document.body
                    if (index === 0) {
                        scrTop.scrollTop = 0
                    } else if (index == this.showIndexLaw) {
                        scrTop.scrollTop = this.$refs[obj].offsetTop
                    } else {
                        scrTop.scrollTop = this.$refs[obj][0].offsetTop
                    }
                    this.showIndex = index
                })
            },
            changeLeftNav() {
                if (this.isClickScroll) {
                    this.isClickScroll = false
                    return
                }
                let scrTop = document.documentElement || document.body
                let top = scrTop.scrollTop
                for (let i = 0; i <= this.showIndexLaw; i++) {
                    let obj = 'risk' + i
                    // console.log(this.$refs[obj], 'this.$refs[obj]');
                    if (this.$refs[obj] && this.$refs[obj][0]) {
                        if (this.$refs[obj][0].offsetTop < top) {
                            this.showIndex = i
                        }
                    } else {
                        // 这里的else有问题，this.$refs[obj]有undefined 或者[] 的情况，后续排查功能 2022.3.18
                        // console.log(this.$refs[obj], this.$refs[obj][0], 'this.$refs[obj]');
                        // 有'涉诉情况'时再执行,不然在没有'涉诉情况'定位错误
                        if (this.isShowLawsData) {
                            if (this.$refs[obj] && this.$refs[obj].offsetTop < top) {
                                this.showIndex = i
                            }
                        }
                    }
                }
                if (top <= 100) {
                    this.showIndex = 0
                }
            },
            async outPutPdfFn() {
                downLoadPDF.call(
                    this,
                    this.$route.query.surveyId,
                    this.$route.query.enterpriseId,
                    this.surveyName
                )
            },
            getDishonestExecutors() {
                ajax(apiListPC.getDishonestExecutors, {
                    enterpriseId: this.$route.query.enterpriseId,
                }).then((res) => {
                    this.breakPromiseNum = res.data.list ? res.data.list.length : 0
                    this.dishonestExecutors = res.data.list
                })
            },
            flattenDeep(arr) {
                arr.forEach((el) => {
                    Object.assign(this.arrobj, { [el.id]: el.name })
                    if (el.children && el.children.length > 0) {
                        this.flattenDeep(el.children)
                    }
                })
            },
        },
    }
    function numberSort(a, b) {
        return parseInt(a.number) > parseInt(b.number) ? -1 : 1
    }
    function getNowFormatDate() {
        let date = new Date()
        let year = date.getFullYear()
        let month = date.getMonth() + 1
        let strDate = date.getDate()
        if (month >= 1 && month <= 9) {
            month = '0' + month
        }
        if (strDate >= 0 && strDate <= 9) {
            strDate = '0' + strDate
        }
        let currentdate = year + '年' + month + '月' + strDate + '日'
        return currentdate
    }
    function createRiskEcharts(moduleScore, that) {
        let risk = []
        let data = []
        moduleScore.forEach(function (item) {
            risk.push(item.name)
            data.push(item.number)
        })
        let myChart = that.$echarts.init(that.$refs.riskEchart)
        let option = {
            animation: false,
            color: ['#3398DB'],
            toolbox: {
                right: 10,
                top: -5,
                feature: {
                    saveAsImage: {
                        show: that.isPreview,
                        title: '下载图片',
                    },
                },
            },
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    // 坐标轴指示器，坐标轴触发有效
                    type: 'shadow', // 默认为直线，可选为：'line' | 'shadow'
                },
                textStyle: {
                    fontSize: 16, //大小
                    align: 'center', //水平对齐
                },
            },
            grid: {
                top: '8%',
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true,
            },
            xAxis: {
                type: 'category',
                data: risk,
                axisTick: {
                    alignWithLabel: true,
                },
                axisLabel: {
                    interval: 0,
                    rotate: 40,
                },
            },

            yAxis: [
                {
                    type: 'value',
                },
            ],
            label: {
                show: true,
                position: 'top',
            },
            series: [
                {
                    name: '风险数量',
                    type: 'bar',
                    barWidth: 20,
                    data: data,
                    label: {
                        normal: {
                            textStyle: {
                                fontSize: 14,
                            },
                        },
                    },
                    itemStyle: {
                        color: '#5867dd',
                    },
                },
            ],
        }
        if (option && typeof option === 'object') {
            myChart.setOption(option, true)
        }
    }
    function yearSort(a, b) {
        return parseInt(a.key) < parseInt(b.key) ? -1 : 1
    }
    //第二个echarts图  裁判年份
    function createJudgementYearEcharts(judgementYearArr, that) {
        let judgementYearArrSort = judgementYearArr.sort(yearSort)
        let year = []
        let num = []
        judgementYearArrSort.forEach(function (item) {
            if (item.key > 0) {
                year.push(item.key)
                num.push(item.count)
            }
        })
        let myChartSecond = that.$echarts.init(that.$refs.echartsYear)
        let optionSecond = null
        optionSecond = {
            animation: false,
            color: ['#3398DB'],
            title: {
                text: '1、裁判年份',
                textStyle: {
                    color: '#62a36a', //颜色
                    fontStyle: 'normal', //风格
                    fontWeight: 'bold', //粗细
                    fontFamily: 'Microsoft yahei', //字体
                    fontSize: 16, //大小
                    align: 'center', //水平对齐
                },
            },
            toolbox: {
                right: 10,
                top: -5,
                feature: {
                    saveAsImage: {
                        show: that.isPreview,
                        title: '下载图片',
                    },
                },
            },
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    // 坐标轴指示器，坐标轴触发有效
                    type: 'shadow', // 默认为直线，可选为：'line' | 'shadow'
                },
                textStyle: {
                    fontSize: 16, //大小
                    align: 'center', //水平对齐
                },
            },
            grid: {
                top: '8%',
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true,
            },
            yAxis: {
                type: 'category',
                data: year,
                axisTick: {
                    alignWithLabel: true,
                },
                axisLabel: {
                    interval: 0,
                    // rotate: 40
                },
            },
            xAxis: [
                {
                    type: 'value',
                },
            ],
            label: {
                show: true,
                position: 'right',
            },
            series: [
                {
                    // title: '1、裁判年份',
                    name: '裁判年份',
                    type: 'bar',
                    barWidth: '60%',
                    data: num,
                    label: {
                        normal: {
                            textStyle: {
                                fontSize: 14,
                            },
                        },
                    },
                    itemStyle: {
                        color: '#5867dd',
                    },
                },
            ],
        }
        if (optionSecond && typeof optionSecond === 'object') {
            myChartSecond.setOption(optionSecond, true)
        }
    }
    //第三个echarts图  案由分布图
    function createReasonEcharts(reasonArr, that) {
        //计算count的总数量
        let num = 0
        reasonArr.forEach(function (item) {
            num += item.count
        })
        let reasonDataArr = []
        reasonArr.forEach(function (item) {
            let obj = new Object()
            obj.value = item.count
            obj.name =
                item.name + ':' + item.count + '(' + ((item.count * 100) / num).toFixed(2) + '%)'
            reasonDataArr.push(obj)
        })
        let myChartThird = that.$echarts.init(that.$refs.echartsReason)
        let optionThird = null
        optionThird = {
            animation: false,
            toolbox: {
                right: 10,
                top: -5,
                feature: {
                    saveAsImage: {
                        show: that.isPreview,
                        title: '下载图片',
                    },
                },
            },
            title: {
                text: '2、案由分布',
                textStyle: {
                    color: '#62a36a', //颜色
                    fontStyle: 'normal', //风格
                    fontWeight: 'bold', //粗细
                    fontFamily: 'Microsoft yahei', //字体
                    fontSize: 16, //大小
                    align: 'center', //水平对齐
                },
            },
            tooltip: {
                trigger: 'item',
                // formatter: "{a} <br/>{b} : {c} ({d}%)"
                formatter: '{a} <br/>{b}',
                textStyle: {
                    fontSize: 16, //大小
                    align: 'center', //水平对齐
                },
            },
            series: [
                {
                    name: '案由分布',
                    type: 'pie',
                    // radius: ["10%", "55%"],
                    radius: '60%',
                    center: ['50%', '50%'],
                    data: reasonDataArr,
                    label: {
                        normal: {
                            textStyle: {
                                fontSize: 14,
                            },
                        },
                    },
                    itemStyle: {
                        emphasis: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)',
                        },
                        normal: {
                            color: function (params) {
                                let colorList = [
                                    '#1e59a9',
                                    '#51b9b8',
                                    '#f1b07a',
                                    '#f2f2d1',
                                    '#f285a5',
                                    '#e9c73b',
                                    '#39abdd',
                                    '#09c285',
                                    '#a85e0c',
                                    '#d93a49',
                                    '#1e59a9',
                                    '#51b9b8',
                                    '#f1b07a',
                                    '#f2f2d1',
                                    '#f285a5',
                                    '#e9c73b',
                                    '#39abdd',
                                    '#09c285',
                                    '#a85e0c',
                                    '#d93a49',
                                    '#1e59a9',
                                    '#51b9b8',
                                    '#f1b07a',
                                    '#f2f2d1',
                                    '#f285a5',
                                    '#e9c73b',
                                    '#39abdd',
                                    '#09c285',
                                    '#a85e0c',
                                    '#d93a49',
                                ]
                                return colorList[params.dataIndex]
                            },
                        },
                    },
                },
            ],
        }
        if (optionThird && typeof optionThird === 'object') {
            myChartThird.setOption(optionThird, true)
        }
    }
    //第四个echarts图  地区分布图
    function createProvinceEcharts(provinceId, that) {
        that.flattenDeep(COURT_JSON)
        //计算count的总数量
        let num = 0
        provinceId.forEach(function (item) {
            num += item.count
        })
        let provinceDataArr = []
        let otherProportion = 0
        let otherCount = 0
        provinceId.forEach(function (item) {
            let obj = new Object()
            obj.value = item.count
            let proportion = ((item.count * 100) / num).toFixed(2)
            if (proportion > 0.1) {
                obj.name = that.arrobj[item.key] + ':' + item.count + '(' + proportion + '%)'
                provinceDataArr.push(obj)
            } else {
                otherProportion += proportion * 100
                otherCount += item.count
            }
        })
        let obj1 = new Object()
        obj1.value = otherCount
        obj1.name = '其他:' + otherCount + '(' + otherProportion / 100 + '%)'
        provinceDataArr.push(obj1)
        let myChartFourth = that.$echarts.init(that.$refs.echartsArea)
        let optionFourth = null
        optionFourth = {
            animation: false,

            toolbox: {
                right: 10,
                top: -5,
                feature: {
                    saveAsImage: {
                        show: that.isPreview,
                        title: '下载图片',
                    },
                },
            },
            title: {
                text: '3、地区分布',
                textStyle: {
                    color: '#62a36a', //颜色
                    fontStyle: 'normal', //风格
                    fontWeight: 'bold', //粗细
                    fontFamily: 'Microsoft yahei', //字体
                    fontSize: 16, //大小
                    align: 'center', //水平对齐
                },
            },
            tooltip: {
                trigger: 'item',
                // formatter: "{a} <br/>{b} : {c} ({d}%)"
                formatter: '{a} <br/>{b}',
                textStyle: {
                    fontSize: 16, //大小
                    align: 'center', //水平对齐
                },
            },
            series: [
                {
                    name: '地区分布',
                    type: 'pie',
                    radius: '40%',
                    center: ['50%', '55%'],
                    data: provinceDataArr,
                    label: {
                        normal: {
                            textStyle: {
                                fontSize: 14,
                            },
                        },
                    },
                    startAngle: 180,
                    itemStyle: {
                        emphasis: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)',
                        },
                        normal: {
                            color: function (params) {
                                let colorList = [
                                    '#78321e',
                                    '#8e3134',
                                    '#5b0217',
                                    '#f04037',
                                    '#f4a570',
                                    '#a1102d',
                                    '#d93a49',
                                    '#ecc7ea',
                                    '#ef5c9d',
                                    '#ffe548',
                                    '#9d5807',
                                    '#d38c04',
                                    '#bc833a',
                                    '#908b09',
                                    '#5b3e0e',
                                    '#895e1a',
                                    '#f47923',
                                    '#feddbd',
                                    '#52b7c0',
                                    '#74b7a1',
                                    '#27332d',
                                    '#017945',
                                    '#245b1f',
                                    '#1b953c',
                                    '#a4cf5f',
                                    '#bfb448',
                                    '#7e7723',
                                    '#d5d7d6',
                                    '#df9ebd',
                                    '#372243',
                                    '#513143',
                                    '#6749a7',
                                    '#67527f',
                                    '#6b6daa',
                                    '#4f83d2',
                                    '#2b4391',
                                    '#78321e',
                                    '#8e3134',
                                    '#5b0217',
                                    '#f04037',
                                    '#f4a570',
                                    '#a1102d',
                                    '#d93a49',
                                    '#ecc7ea',
                                    '#ef5c9d',
                                ]
                                return colorList[params.dataIndex]
                            },
                        },
                    },
                },
            ],
        }
        if (optionFourth && typeof optionFourth === 'object') {
            myChartFourth.setOption(optionFourth, true)
        }
    }
    //第五个echarts图  法院top10
    function createCourtTop0Echarts(courtTop, that) {
        let count = []
        let name = []
        courtTop.reverse().forEach(function (item) {
            count.push(item.count)
            name.push(item.name)
        })
        let myChartSecond = that.$echarts.init(that.$refs.echartsCourt)
        let optionSecond = null
        optionSecond = {
            animation: false,
            toolbox: {
                right: 10,
                top: -5,
                feature: {
                    saveAsImage: {
                        show: that.isPreview,
                        title: '下载图片',
                    },
                },
            },
            color: ['#3398DB'],
            title: {
                text: '4、法院',
                textStyle: {
                    color: '#62a36a', //颜色
                    fontStyle: 'normal', //风格
                    fontWeight: 'bold', //粗细
                    fontFamily: 'Microsoft yahei', //字体
                    fontSize: 16, //大小
                    align: 'center', //水平对齐
                },
            },
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    // 坐标轴指示器，坐标轴触发有效
                    type: 'shadow', // 默认为直线，可选为：'line' | 'shadow'
                },
                textStyle: {
                    fontSize: 16, //大小
                    align: 'center', //水平对齐
                },
            },
            grid: {
                top: '8%',
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true,
            },
            xAxis: [
                {
                    type: 'value',
                },
            ],
            yAxis: {
                type: 'category',
                data: name,
                axisLabel: {
                    interval: 0,
                },
            },
            label: {
                show: true,
                position: 'right',
            },
            series: [
                {
                    name: '法院',
                    type: 'bar',
                    barWidth: '60%',
                    data: count,
                    label: {
                        normal: {
                            textStyle: {
                                fontSize: 14,
                            },
                        },
                    },
                    itemStyle: {
                        color: '#35a042',
                    },
                },
            ],
        }
        if (optionSecond && typeof optionSecond === 'object') {
            myChartSecond.setOption(optionSecond, true)
        }
    }
    //第六个echarts图  审理程序分布图
    function createProcedureEcharts(procedure, that) {
        let PROCEDURE_JSON = {
            1: '一审',
            2: '二审',
            3: '审判监督',
            4: '没收违法所得',
            5: '刑事复核',
            6: '强制医疗',
            7: '刑罚与执行变更',
            8: '其他',
            9: '第三人撤销之诉',
            10: '特别程序',
            11: '催告案件',
            12: '督促案件',
            13: '破产/强制清算',
            14: '非诉审查',
            15: '执行实施',
            16: '执行审查',
            17: '其他执行',
            18: '财产保全',
            19: '行为保全',
            20: '行为保全复议',
            21: '证据保全',
            22: '行政赔偿',
            23: '司法赔偿',
            24: '其他赔偿',
            25: '司法救助',
            26: '其他司法救助',
            27: '认可与执行申请审查',
            28: '送达文书',
            29: '调查取证',
            30: '被判刑人移管',
            31: '罪赃移交',
            32: '引渡',
            33: '司法制裁审查',
            34: '司法制裁复议',
            35: '管辖',
        }
        let procedureDataArr = []
        //计算count的总数量
        let num = 0
        procedure.forEach(function (item) {
            num += item.count
        })
        procedure.forEach(function (item) {
            let obj = new Object()
            obj.value = item.count
            obj.name =
                PROCEDURE_JSON[item.key] +
                ':' +
                item.count +
                '(' +
                ((item.count * 100) / num).toFixed(2) +
                '%)'
            procedureDataArr.push(obj)
        })
        let myChartThird = that.$echarts.init(that.$refs.echartsProgress)
        let optionThird = null
        optionThird = {
            animation: false,
            toolbox: {
                right: 10,
                top: -5,
                feature: {
                    saveAsImage: {
                        show: that.isPreview,
                        title: '下载图片',
                    },
                },
            },
            title: {
                text: '5、审理程序',
                textStyle: {
                    color: '#62a36a', //颜色
                    fontStyle: 'normal', //风格
                    fontWeight: 'bold', //粗细
                    fontFamily: 'Microsoft yahei', //字体
                    fontSize: 16, //大小
                    align: 'center', //水平对齐
                },
            },
            tooltip: {
                trigger: 'item',
                // formatter: "{a} <br/>{b} : {c} ({d}%)"
                formatter: '{a} <br/>{b}',
                textStyle: {
                    fontSize: 16, //大小
                    align: 'center', //水平对齐
                },
            },
            series: [
                {
                    name: '审理程序',
                    type: 'pie',
                    radius: ['30%', '60%'],
                    center: ['50%', '58%'],
                    data: procedureDataArr,
                    label: {
                        normal: {
                            textStyle: {
                                fontSize: 14,
                            },
                        },
                    },
                    itemStyle: {
                        emphasis: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)',
                        },
                        normal: {
                            color: function (params) {
                                let colorList = [
                                    '#fde79d',
                                    '#92d101',
                                    '#f68b26',
                                    '#52b7c0',
                                    '#fd4141',
                                    '#26b4f6',
                                    '#fde79d',
                                    '#92d101',
                                    '#f68b26',
                                    '#52b7c0',
                                    '#fd4141',
                                    '#26b4f6',
                                ]
                                return colorList[params.dataIndex]
                            },
                        },
                    },
                },
            ],
        }
        if (optionThird && typeof optionThird === 'object') {
            myChartThird.setOption(optionThird, true)
        }
    }
    //第七个echarts图  律师top10
    function createlawyerListTopEcharts(lawyerListTop, that) {
        let count = []
        let name = []
        lawyerListTop.reverse().forEach(function (item) {
            count.push(item.count)
            name.push(item.key)
        })
        let myChartSecond = that.$echarts.init(that.$refs.echartsLawyer)
        let optionSecond = null
        optionSecond = {
            animation: false,
            toolbox: {
                right: 10,
                top: -5,
                feature: {
                    saveAsImage: {
                        show: that.isPreview,
                        title: '下载图片',
                    },
                },
            },
            title: {
                text: '6、律师',
                textStyle: {
                    color: '#62a36a', //颜色
                    fontStyle: 'normal', //风格
                    fontWeight: 'bold', //粗细
                    fontFamily: 'Microsoft yahei', //字体
                    fontSize: 16, //大小
                    align: 'center', //水平对齐
                },
            },
            color: ['#3398DB'],
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    // 坐标轴指示器，坐标轴触发有效
                    type: 'shadow', // 默认为直线，可选为：'line' | 'shadow'
                },
                textStyle: {
                    fontSize: 16, //大小
                    align: 'center', //水平对齐
                },
            },
            grid: {
                top: '8%',
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true,
            },
            xAxis: {
                type: 'value',
            },
            yAxis: {
                type: 'category',
                data: name,
                axisTick: {
                    alignWithLabel: true,
                },
                axisLabel: {
                    interval: 0,
                },
            },
            label: {
                show: true,
                position: 'right',
            },
            series: [
                {
                    name: '律师',
                    type: 'bar',
                    data: count,
                    label: {
                        normal: {
                            textStyle: {
                                fontSize: 14,
                            },
                        },
                    },
                    itemStyle: {
                        color: '#5867dd',
                    },
                    barWidth: 20,
                },
            ],
        }
        if (optionSecond && typeof optionSecond === 'object') {
            myChartSecond.setOption(optionSecond, true)
        }
    }
</script>

<style lang="less" type="text/less" scoped>
    .watermark-box {
        opacity: 1;
        .watermark {
            position: fixed;
            transform: rotate(-20deg);
            z-index: 99;
            color: rgba(200, 200, 200, 0.4);
            font-size: 18px;
            font-family: 'Vedana';
        }
    }

    .cover {
        page-break-after: always;
        padding-top: 40mm;
        background-image: url(../../../static/images/report_cover_beij.png);
        background-position: 60% 160%;
        background-repeat: no-repeat;
        background-size: 160% 80%;
        .pdf-cover-logo {
            img {
                width: 50mm;
            }
            div {
                font-size: 12mm;
                font-weight: 900;
                margin-top: 10px;
            }
        }
        .pdf-cover-title {
            margin-top: 40mm;

            &-surveyName {
                font-size: 8mm;
                color: #666;
            }
            &-message {
                font-size: 8mm;
                color: #666;
            }
        }

        .pdf-cover-time {
            margin-top: 120mm;
            font-size: 6mm;
            color: #333;
            letter-spacing: 1mm;
        }
    }
    .down-review {
        max-width: 1000px !important;
        margin: 0px auto 20px !important;
        // transform: scale(1.1);
    }
    .global-content {
        margin: 40px auto 20px;
        text-align: center;
        .report-left {
            // width: 180px;
            position: sticky;
            top: 0px;
            left: 13px;
            float: left;
            padding-top: 20px;
            flex: 1;
            div {
                font-size: 16px;
                color: #5867dd;
                width: 160px;
                margin-left: 20px;
                margin-bottom: 20px;
                text-align: left;
                font-weight: 700;
                border-bottom: 1px solid #5867dd;
                cursor: default;
                img {
                    width: 36px;
                    height: 36px;
                }
            }
            li {
                list-style: none;
                text-align: left;
                // width: 160px;
                margin-left: 20px;
                padding-left: 8px;
                line-height: 50px;
                border-radius: 5px;
                background: rgba(250, 250, 250, 1);
                cursor: pointer;
                position: relative;
                z-index: 2;
                padding: 0 10px;
                // &:last-child {
                //     height: 64px;
                //     margin-top: 10px;
                //     background: url('../../../static/images/laws.png');
                //     background-size: 100% 100%;
                //     line-height: 64px;
                //     color: #fff;
                //     text-align: center;
                //     img {
                //         height: 30px;
                //         width: 30px;
                //         margin-right: 0px;
                //     }
                // }
                &.active {
                    background: #5867dd;
                    color: #fff;
                }
                img {
                    height: 30px;
                    width: 30px;
                    margin-right: 8px;
                }
                span {
                    display: block;
                    position: absolute;
                    width: 10px;
                    height: 10px;
                    right: -5px;
                    top: 20px;
                    background: #5867dd;
                    transform: rotate(45deg);
                    z-index: -1;
                }
            }
        }

        .report-right {
            // width: 800px;
            border: 1px solid rgba(235, 235, 235, 1);
            padding: 0px 20px 30px;
            margin: 20px 0 20px 250px;
            position: relative;
            // width: 95%;
            // .clientele-logo {
            //     width: 112px;
            //     height: 107px;
            //     float: left;
            //     margin-top: -21px;
            //     margin-left: 20px;
            // }
            .risk-level {
                width: 112px;
                height: 107px;
                top: 60px;
                right: 20px;
                position: absolute;
            }
            h1 {
                font-size: 28px;
                font-weight: 400;
                color: #2a3354;
                letter-spacing: 3px;
                height: 54px;
                background: #fff url('../../../static/images/report-title.png');
                background-size: 100% 102%;
                width: 372px;
                margin: 0 auto;
            }

            ::v-deep(.ant-progress-text) {
                white-space: pre-line;
                width: 70%;
            }

            h2 {
                text-align: left;
                font-size: 18px;
            }
            .row {
                height: 50px;
                line-height: 50px;
                text-align: center;

                .left1 {
                    color: #2a3354;
                    font-size: 18px;

                    label {
                        font-size: 18px;
                        font-weight: 700;
                    }
                }

                .right {
                    color: #6f7899;
                    font-size: 14px;
                }
            }
            .noRisk {
                text-indent: 0 !important;
            }
            .bg {
                background: #f9f9f9;
                margin-bottom: 2px;
                text-align: left;
                .riskEchart {
                    width: 650px;
                    height: 330px;
                    float: left;
                }
                .riskTable {
                    // width: 300px;
                    height: 100%;
                    float: right;
                    overflow-y: auto;
                    .riskList {
                        width: 100%;
                        height: 40px;
                        padding: 0 5px;
                        span {
                            display: block;
                            float: left;
                            height: 40px;
                            line-height: 40px;
                        }
                        .riskList-rank {
                            // width: 60px;
                            padding: 0 5px;
                            strong {
                                display: inline-block;
                                border-radius: 50%;
                                width: 25px;
                                height: 25px;
                                background: #efefef;
                                color: #fff;
                                text-align: center;
                                line-height: 25px;
                                &.rank {
                                    background: #5867dd;
                                }
                            }
                        }
                        .riskList-name {
                            width: 140px;
                        }
                        .riskList-num {
                            // width: 80px;
                            padding: 0 5px;
                        }
                    }
                }
                .pie {
                    float: left;
                    width: 100px;
                    height: 100px;
                    position: relative;
                    .pie-right {
                        position: absolute;
                        width: 100px;
                        height: 100px;
                        border-radius: 50%;
                        background: yellow;
                        z-index: 999;
                    }
                    .pie-left {
                        position: absolute;
                        width: 100px;
                        height: 100px;
                        border-radius: 50%;
                        background: yellow;
                        z-index: 999;
                    }
                    .right {
                        position: absolute;
                        width: 100px;
                        height: 100px;
                        border-radius: 50%;
                        background: #f1f1f1;
                        z-index: 99;
                    }
                    .left {
                        position: absolute;
                        width: 100px;
                        height: 100px;
                        border-radius: 50%;
                        background: #f1f1f1;
                        z-index: 99;
                    }
                    .pie-left {
                        clip: rect(0, 50px, auto, auto);
                    }
                    .left {
                        clip: rect(0, 50px, auto, auto);
                    }
                    .pie-right {
                        clip: rect(0, auto, auto, 0px);
                    }
                    .right {
                        clip: rect(0, auto, auto, 50px);
                    }

                    .mask {
                        position: absolute;
                        top: 10px;
                        left: 10px;
                        width: 80px;
                        height: 80px;
                        border-radius: 50%;
                        background: white;
                        padding: 20px 0;
                        text-align: center;
                        z-index: 990;
                    }
                }
            }
            .txtindent {
                text-indent: 15px;
            }
            #riskInfoBox {
                .danger-list {
                    width: 100%;
                    text-align: left;
                    .danger-title {
                        font-size: 16px;
                        color: #2a3354;
                        height: 35px;
                        line-height: 35px;
                        margin: 30px auto;
                        img {
                            height: 34px;
                            margin-right: 10px;
                        }
                    }
                    .detail-list {
                        width: auto;
                        margin: 10px 0px 0;
                        .detail-header {
                            display: flex;
                            justify-content: space-between;
                            border: 1px solid #eee;
                            align-items: center;
                            .detail-title {
                                display: flex;
                                font-size: 16px;
                                color: #5867dd; /*******提炼出来*******/
                                font-weight: 400;
                                min-height: 34px;
                                line-height: 34px;
                                font-weight: 600;
                                padding: 15px 20px;
                                // border-bottom: none;
                                flex: 1;
                                span {
                                    width: 30px;
                                    min-width: 30px;
                                    height: 30px;
                                    line-height: 30px;
                                    color: #fff;
                                    text-align: center;
                                    margin-right: 10px;
                                    /*background:#015FA7;*/ /*******提炼出来*******/
                                    background: #5867dd;
                                    border-radius: 50%;
                                    font-size: 14px;
                                }
                            }
                            .detail-header-legalScope {
                                width: 25px;
                                height: 25px;
                                margin: 10px;
                            }
                        }
                        .form-group {
                            width: 100%;
                            background: rgba(245, 246, 248, 1);
                            padding-bottom: 10px;
                            .fix-title {
                                width: auto;
                                margin: 21px 44px 10px 60px;
                                line-height: 24px;
                                color: #666;
                            }
                            .analyseCont {
                                text-align: justify;
                                width: 86%;
                                margin: 0px 44px 20px 60px;
                                line-height: 24px;
                                color: #666;
                            }
                        }
                        .case {
                            width: 100%;
                            padding-top: 5px;
                            line-height: 2;
                            span {
                                font-size: 14px;
                                display: flex;
                                em {
                                    padding-left: 20px;
                                    width: 60px;
                                    font-style: normal;
                                }
                                a {
                                    flex: 1;
                                    white-space: nowrap;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                }
                                // margin-bottom: 5px;
                                // line-height: 3;
                            }
                        }

                        .lawsTitle {
                            color: #2c3e50;
                            font-style: normal;
                        }
                        ::v-deep(.ant-collapse-header) {
                            color: #5867dd;
                            padding: 5px 20px;
                            text-align: left;
                        }
                    }
                    /*&:nth-child(3n+1) .detail-title{
            color:#62a36a;
          }
          &:nth-child(3n+1) .detail-title span{
            background:#62a36a;
          }
          &:nth-child(3n+1) .detail-list .form-group{
            background:#f5fdf6;
          }
          &:nth-child(3n+2) .detail-title{
            color:#5867dd;
          }
          &:nth-child(3n+2) .detail-title span{
            background:#5867dd;
          }
          &:nth-child(3n+2) .detail-list .form-group{
            background:#ebedf8;
          }
          &:nth-child(3n+3) .detail-title{
            color:#faa30b;
          }
          &:nth-child(3n+3) .detail-title span{
            background:#faa30b;
          }
          &:nth-child(3n+3) .detail-list .form-group{
            background:#fdfaec;
          }*/
                }
            }
            .echarts-box {
                width: 100%;
                .lawuit-title {
                    font-size: 18px;
                    color: #2a3354;
                    font-weight: 600;
                    text-align: left;
                    margin-top: 30px;
                }
                .lawuit-list-title {
                    color: #62a36a;
                    font-size: 14px;
                    font-weight: 600;
                    margin-top: 20px;
                    text-align: left;
                }
                .echarts-list {
                    // *一定要设置初始宽度！！！
                    width: 890px;
                    height: 650px;
                    margin-top: 20px;
                }
                .echarts-list-area {
                    width: 890px;
                    height: 800px;
                    margin-top: 20px;
                }
            }
        }
        .loadingBg {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(0, 0, 0, 0.1);
            .loadingBox {
                position: fixed;
                top: 50%;
                left: 50%;
                margin-top: -125px;
                margin-left: -150px;
                width: 300px;
                background: #fff;
                .loading-title {
                    width: 100%;
                    color: #5867dd;
                    font-size: 18px;
                    margin-top: 30px;
                }
                .loading-img {
                    width: 115px;
                    height: 115px;
                    margin: 38px auto;
                    position: relative;
                    img {
                        width: 100%;
                        height: 100%;
                        animation: loadingCss3 1s infinite linear;
                    }
                    span {
                        position: absolute;
                        width: 70px;
                        height: 70px;
                        top: 22.5px;
                        left: 22.5px;
                        font-size: 22px;
                        color: #5867dd;
                        text-align: center;
                        line-height: 70px;
                    }
                }
                .loading-info {
                    font-size: 16px;
                    color: #5867dd;
                    margin-bottom: 36px;
                }
                @keyframes loadingCss3 {
                    0% {
                        transform: rotate(0);
                    }
                    100% {
                        transform: rotate(360deg);
                    }
                }
            }
        }
        .dishonest {
            background: #efefef;
            margin-bottom: 10px;
        }
        .borLeft2 {
            border-left: 6px solid #5867dd;
            text-indent: 20px;
            color: #333;
        }
        .shengming {
            color: #888;
            font-size: 12px;
            line-height: 28px;
        }
    }
    @media print {
        @page {
            margin: 40px 0; /* 设置打印边距为20px */
        }

        .detail-title,
  .detail-analyse,
  // .analyseCont,
  .case,
  .lawsTitle,
  .echarts-list,.detail-header {
            page-break-inside: avoid;
        }

        .echarts-list {
            filter: brightness(0.8);
        }
    }

    .lock {
        background-color: #ccc;
        border-color: #ccc;
    }
</style>
